export const TOASTS = {
  success: { title: 'Preferência cadastrada com sucesso!', description: null },
  error: {
    title: 'Algum erro aconteceu!',
    description: 'Tivemos algum problema técnico. Tente novamente mais tarde.',
  },
};
